import { render } from "./Toggle.vue?vue&type=template&id=57cc3b70"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Toggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57cc3b70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57cc3b70', __exports__)) {
    api.reload('57cc3b70', __exports__)
  }
  
  module.hot.accept("./Toggle.vue?vue&type=template&id=57cc3b70", () => {
    api.rerender('57cc3b70', render)
  })

}


export default __exports__